import { MARQUEE_ITEMS } from "../../data/content";

export default function Marquee({ items = MARQUEE_ITEMS, className = "", fast = false, dark = false }) {
  return (
    <div
      className={`overflow-hidden whitespace-nowrap border-y ${dark ? "border-woodborder bg-wood" : "border-woodborder bg-obsidian"} ${className}`}
      data-testid="marquee"
    >
      <div className={`inline-flex items-center py-4 ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        {[0, 1].map((n) => (
          <div key={n} className="flex items-center shrink-0" aria-hidden={n === 1}>
            {items.map((t, i) => (
              <span key={i} className="flex items-center shrink-0">
                <span className="font-display text-2xl md:text-3xl tracking-wider text-cream/70 px-8">{t}</span>
                <span className="text-burnt text-lg">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
